'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from '@lichtblick/link';
import { BoxCTALabel } from '@lichtblick/photon/atoms/box-cta/box-cta-label';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { HighlightIcon } from '@lichtblick/photon/atoms/highlight-icon';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { MegaphoneS } from '@lichtblick/photon/icons/objects/megaphone-s';
import { SpeechBubbleS } from '@lichtblick/photon/icons/objects/speech-bubble-s';
import { ExclamationMarkTriangleS } from '@lichtblick/photon/icons/symbols/exclamation-mark-triangle-s';
import themes from '@lichtblick/photon/theme/theme.module.css';
import { useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import { useCallback } from 'react';
import { assertExhaustive } from '../../helpers/assertExhaustive';
import { buildUrl } from '../../helpers/links';
import styles from './m-column-teaser-item.module.css';
/**
 * Maps legacy Storyblok theme values to the new theme system.
 * TODO: Remove this mapping after content migration is complete.
 */ const themeColorMap = {
    green: 'moss-strong',
    moss: 'moss-strong',
    'dark-berry': 'berry-strong',
    berry: 'berry-strong',
    smoke: 'smoke-strong'
};
const Icon = ({ icon })=>{
    if (!icon) {
        return null;
    }
    switch(icon){
        case 'alert-s':
            return /*#__PURE__*/ _jsx(ExclamationMarkTriangleS, {});
        case 'notification-s':
            return /*#__PURE__*/ _jsx(MegaphoneS, {});
        case 'speech-bubble-s':
            return /*#__PURE__*/ _jsx(SpeechBubbleS, {});
        default:
            assertExhaustive(icon);
    }
};
export const MColumnTeaserItem = ({ theme, headline, icon, link, linkLabel, text, trackingOption })=>{
    const { trackCustomEvent } = useTracker();
    const href = link ? buildUrl(link) : undefined;
    const themeName = themeColorMap[theme] ?? theme;
    const handleEvent = useCallback(()=>{
        if (trackingOption?.[0]?.eventName) {
            trackCustomEvent({
                eventName: trackingOption[0].eventName,
                customProps: trackingOption[0].customProps && JSON.parse(trackingOption[0].customProps)
            });
        }
    }, [
        trackCustomEvent,
        trackingOption
    ]);
    return /*#__PURE__*/ _jsxs(Link, {
        className: classNames(styles.container, themes[themeName], styles['link-container']),
        "data-testid": "column-teaser-item",
        href: href || '',
        onClick: handleEvent,
        children: [
            /*#__PURE__*/ _jsx(HighlightIcon, {
                theme: themeName,
                className: styles.icon,
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: icon
                })
            }),
            /*#__PURE__*/ _jsx(Headline, {
                className: styles.headline,
                size: "s",
                children: headline
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.text,
                children: text
            }),
            href && /*#__PURE__*/ _jsx(BoxCTALabel, {
                className: styles.button,
                size: "small",
                variant: "neutral-outline",
                children: linkLabel
            })
        ]
    });
};

//# sourceMappingURL=m-column-teaser-item.js.map